var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_398_20879)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.70664 1.29395C6.31602 0.90332 5.68164 0.90332 5.29102 1.29395L0.291016 6.29395C-0.0996094 6.68457 -0.0996094 7.31894 0.291016 7.70957C0.681641 8.10019 1.31602 8.10019 1.70664 7.70957L5.00039 4.4127V14.0002C5.00039 14.5533 5.44727 15.0002 6.00039 15.0002C6.55352 15.0002 7.00039 14.5533 7.00039 14.0002V4.4127L10.2941 7.70645C10.6848 8.09707 11.3191 8.09707 11.7098 7.70645C12.1004 7.31582 12.1004 6.68145 11.7098 6.29082L6.70977 1.29082L6.70664 1.29395Z",
    fill: "#FD003B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_398_20879"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H12V16H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedUpIcon);
export default __webpack_public_path__ + "static/media/red-up-icon.27772d649616f85bcf425155ee838b12.svg";
export { ForwardRef as ReactComponent };